const { getElement } = window.BAO.Utils

export class SiteDrawer extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.drawers = getElement('site-drawers')
    if (!this.drawers) {
      throw new Error(
        `${this.nodeName.toLowerCase()} needs a <site-drawers> element to work`,
      )
    }
    this.drawers.drawers.push(this)

    this._isOpen = false
  }

  connectedCallback () {
    super.connectedCallback()

    const openOnLoad = this.hasAttribute('data-site-drawers-open-on-load')
    const hasTimer = this.hasAttribute('data-site-drawers-timer')
    const timerComplete =
      window.sessionStorage.getItem(this.timerStorageKey) === 'true'
    const dismissed =
      window.sessionStorage.getItem(this.dismissedStorageKey) === 'true'

    if (!dismissed && (openOnLoad || (hasTimer && timerComplete))) {
      this.removeTransitionEffect()
      this.drawers.activeDrawerKey = this.key
    } else if (!dismissed && hasTimer) {
      this.runTimer(Number(this.dataset.delay))
    }

    if (this.drawerShouldBeMoved) {
      window.setTimeout(() => {
        this.moveToElement.appendChild(this)
      }, parseInt(this.getAttribute('data-module-drawers-move-delay'), 10) || 0)
    }
  }

  get key () {
    return this.getAttribute('key')
  }

  get timerStorageKey () {
    return `site-drawer-${this.key}-timer-complete`
  }

  get dismissedStorageKey () {
    return `site-drawer-${this.key}-dismissed`
  }

  removeTransitionEffect () {
    this.style.transition = 'none'

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        this.style.removeProperty('transition')
      })
    })
  }

  get elements () {
    return {
      trigger: getElement(`[data-drawers-trigger=${this.key}]`),
      close: getElement(`[data-module-drawers-close=${this.key}]`),
    }
  }

  get isOpen () {
    return this._isOpen
  }

  get overlayEnabled () {
    return this.getAttribute('data-site-drawers-overlay') !== 'false'
  }

  get siteOverflowEnabled () {
    return this.getAttribute('data-site-drawers-overflow') !== 'false'
  }

  set isOpen (val) {
    this._isOpen = val

    this.classList.toggle(this.config.classes.activeDrawerClass, val)
  }

  get drawerShouldBeMoved () {
    return this.hasAttribute('data-module-drawers-move-me')
  }

  get moveToElement () {
    switch (this.getAttribute('data-module-drawers-move-me')) {
      case 'root':
        return this.drawers
      default:
        return getElement(this.getAttribute('data-module-drawers-move-me'))
    }
  }

  get config () {
    return {
      classes: {
        activeDrawerClass: 'drw-Drawer-active',
      },
    }
  }

  runTimer (seconds) {
    window.setTimeout(() => {
      window.sessionStorage.setItem(this.timerStorageKey, 'true')
      this.drawers.activeDrawerKey = this.key
    }, seconds)
  }
}

customElements.define('site-drawer', SiteDrawer)
